var _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDensity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "density",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 426.667 426.667",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "128,426.667 426.667,426.667 426.667,128 "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 133.206,
    y: 131.905,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -80.7655 196.8245)",
    width: 127.999,
    height: 127.999
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "57.6,27.733 85.333,0 0,0 0,85.333 27.733,57.6 76.8,106.667 106.667,76.8 "
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "320,0 347.733,27.733 298.667,76.8 328.533,106.667 377.6,57.6 405.333,85.333 405.333,0 "
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "106.667,328.533 76.8,298.667 27.733,347.733 0,320 0,405.333 85.333,405.333 57.6,377.6 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDensity);
export default __webpack_public_path__ + "static/media/density.0d4916c96a44313edd688513d8668e49.svg";
export { ForwardRef as ReactComponent };